'use client';

import {
  Button,
  Input,
  VStack,
  Box,
  SimpleGrid,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { CField } from '@/_components/CField';
import { InputGroup } from '@/components/ui/input-group';
import { ClearIcon } from '@/_assets/icon-components';
import { IPoint } from '@/_store/common/types';

const Desktop = ({
  formData,
  clearInput,
  handleInputChange,
}: {
  formData: IPoint;
  clearInput: () => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const t = useTranslations();

  return (
    <VStack gap={8} bottom={0} left={0} bg='background.card' mt={4} zIndex={10}>
      <Box bottom='100%' left={0} w='100%' bg='background.card'>
        {/* <Flex flexDir={'column'} justifyContent='space-between' mb={4}>
          <InputGroup
            flex={1}
            endElement={
              formData.name && (
                <IconButton
                  variant={'plain'}
                  rounded={'full'}
                  onClick={clearInput}
                >
                  <ClearIcon />
                </IconButton>
              )
            }
          >
            <CField label={t('title')} size='sm' bgColor='background'>
              <Input
                placeholder=''
                className='peer'
                outlineColor={'primary'}
                name='name'
                value={formData?.name}
                onChange={handleInputChange}
                bg='background'
                _placeholder={{
                  color: 'text.muted',
                }}
              />
            </CField>
          </InputGroup>
        </Flex> */}
        <SimpleGrid columns={2} gap={4}>
          <CField label={t('house')} size='sm' bgColor='background'>
            <Input
              placeholder=''
              maxLength={10}
              className='peer'
              name='accommodation'
              outlineColor={'primary'}
              value={formData?.accommodation}
              onChange={handleInputChange}
            />
          </CField>
          <CField label={t('apartment')} size='sm' bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='apartment'
              outlineColor={'primary'}
              value={formData?.apartment}
              onChange={handleInputChange}
            />
          </CField>
          {/* <CField label={t('floor')} size='sm' bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='floor'
              value={formData?.floor}
              outlineColor={'primary'}
              onChange={handleInputChange}
            />
          </CField>
          <CField label={t('enterance')} size='sm' bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='building'
              value={formData?.building}
              outlineColor={'primary'}
              onChange={handleInputChange}
            />
          </CField> */}
        </SimpleGrid>
        {/* <CField label={t('comment_to_courier')} bgColor='background'>
          <Input
            placeholder=''
            className='peer'
            outlineColor={'primary'}
            name='to_address_description'
            value={formData?.to_address_description}
            onChange={handleInputChange}
          />
        </CField> */}
      </Box>
    </VStack>
  );
};

export default Desktop;
